import AccountInfo from "state/AccountInfo";
import GTagReporter from "landings/Analytics/GA/GTagReporter";
import MixpanelReporter from "./Mixpanel/MixpanelReporter";
import BaseReporter from "landings/Analytics/BaseReporter";
import Constants from "utils/Constants";
import { useQueryParams } from "commonUse/tools";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { EventName } from "landings/Analytics/EventName";
import FBPixelReporter from "./FB";

const commonReportData = {
    form_web: 1,
    app_id: Constants.clientId,
    fpd_id: Constants.fpDid,
};

/**
 * 聚合所有数据上报
 */
class ReportProxy<R extends { [channel in string]: BaseReporter }, C extends keyof R> extends BaseReporter {
    constructor(public reporters: R) {
        super();
    }
    private _supportedReporterChannels: C[];
    get supportedReporterChannels() {
        if (!this._supportedReporterChannels) this._supportedReporterChannels = Object.keys(this.reporters) as C[];
        return this._supportedReporterChannels;
    }
    /**
     * 若要新增统一处理器，请在上层基础类新增接口实现
     */
    setProfile(locale: string, accountInfo: AccountInfo) {
        this.supportedReporterChannels.forEach((channel) => {
            this.reporters[channel]?.setProfile(locale, accountInfo);
        });
    }

    report(eventName: string, data: object = {}) {
        this.supportedReporterChannels.forEach((channel) => {
            this.reporters[channel]?.report(eventName, { ...commonReportData, ...data });
        });
    }

    reset() {
        this.supportedReporterChannels.forEach((channel) => {
            this.reporters[channel]?.reset();
        });
    }

    updateProfile(userId: string, profile: {}) {
        this.supportedReporterChannels.forEach((channel) => {
            this.reporters[channel]?.updateProfile(userId, profile);
        });
    }
}

/**
 * 注册并初始化各个上报频道对象
 */
export const DataReporter = new ReportProxy({
    gtag: new GTagReporter(),
    mixpanel: new MixpanelReporter(),
    fbp: new FBPixelReporter(),
});

export default DataReporter;

/**
 * 进入页面时上报
 * @param eventName
 * @param getExtraParams 生成除了默认from字段外的其他自定义字段
 */
export function useEnterReport(eventName: string, getExtraParams?: (queryParams: URLSearchParams) => Undefinable<Record<string, any>>) {
    const queryParams = useQueryParams();
    const { state } = useLocation<{ from?: string }>();
    const queryFrom = queryParams.get("from");

    useEffect(() => {
        DataReporter.report(eventName, {
            web_enter_from: state?.from || queryFrom,
            ...getExtraParams?.(queryParams),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
